import type { PathItem } from '@mimir/primitive/pathItem';

/**
 * Constructs a folder path (e.g. foo/bar/) to upload item to a folder structure in S3
 * @param folders Array of objects that at least has the 'name' of the folder as a property
 * @param initialValue
 */
export const constructUploadFolderPath = (folders: { name: string }[], initialValue: string) => {

  return folders.reduce((path: string, curFolder: { name: string }) => {
    // Checking length < 1 as '/' at the start of the path will end up creating a folder with no name in S3
    return `${path}${path.length < 1 ? '' : '/'}${curFolder.name}`;
  }, initialValue);
};

/**
 * Uploading P2 parts to an S3 Gateway like minio supposes that Kelda
 * will pick these files and process them, which will eventually result in
 * the final file(s) being moved to a bucket folder where the Mimir folder
 * structure will not be preserved.
 *
 * If a Mimir path looks like a P2 path, we retain a path of the form
 * <P2 folder ID>/[CLIP|AUDIO|VIDEO|AVCLIP]; otherwise, we use an empty path
 * so that the file will end up in the root of the upload folder.
 */
export const constructS3CloneUploadPath = (pathItems: PathItem[]): string => {
  const last2Levels = pathItems.slice(-2);
  if (last2Levels.length !== 2) {
    return '';
  }
  if (last2Levels[1]!.name !== 'AUDIO' && last2Levels[1]!.name !== 'VIDEO' && last2Levels[1]!.name !== 'CLIP' && last2Levels[1]!.name !== 'AVCLIP') {
    return '';
  }
  return `${last2Levels[0]!.folderId}/${last2Levels[1]!.name}`;
};
